import { X } from "lucide-react";
import { useEffect } from "react";
import "./credit-modal.css";

export function CreditModal({ isCreditsModalOpen, setIsCreditsModalOpen }) {
  useEffect(() => {
    if (isCreditsModalOpen) {
      document.body.style.overflow = "hidden";
    } else {
      document.body.style.overflow = "unset";
    }

    return () => {
      document.body.style.overflow = "unset";
    };
  }, [isCreditsModalOpen]);

  if (!isCreditsModalOpen) return null;
  return (
    <div className="r2-credit-modal">
      <div className="r2-credit-modal__card">
        <div className="r2-credit-modal__header">
          <h3 className="r2-credit-modal__title">
            Credit Pricing
          </h3>
          <button
            onClick={() => setIsCreditsModalOpen(false)}
            className="r2-credit-modal__close"
          >
            <X className="r2-credit-modal__close-icon" />
          </button>
        </div>
        <div className="r2-credit-modal__body">
          <table className="r2-credit-modal__table">
            <thead>
              <tr className="r2-credit-modal__row r2-credit-modal__row--head">
                <th className="r2-credit-modal__cell r2-credit-modal__cell--head">
                  Product
                </th>
                <th className="r2-credit-modal__cell r2-credit-modal__cell--head">
                  Credits
                </th>
              </tr>
            </thead>
            <tbody>
              <tr className="r2-credit-modal__row">
                <td className="r2-credit-modal__cell">
                  Identification & Biometrics
                </td>
                <td className="r2-credit-modal__cell">1</td>
              </tr>
              <tr className="r2-credit-modal__row">
                <td className="r2-credit-modal__cell">
                  Criminal Record Check
                </td>
                <td className="r2-credit-modal__cell">1</td>
              </tr>
              <tr className="r2-credit-modal__row">
                <td className="r2-credit-modal__cell">
                  Driver's License Status
                </td>
                <td className="r2-credit-modal__cell">1</td>
              </tr>
              <tr className="r2-credit-modal__row">
                <td className="r2-credit-modal__cell">
                  Personal Insurance Validation
                </td>
                <td className="r2-credit-modal__cell">1</td>
              </tr>
              <tr className="r2-credit-modal__row">
                <td className="r2-credit-modal__cell">
                  Motor Vehicle Report (MVR)
                </td>
                <td className="r2-credit-modal__cell">3</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
}
